module.exports = JSON.parse("{\"countries\":[{\"id\":47,\"name\":\"Deutschland\",\"DhlZone\":1,\"mwst\":19,\"iso\":\"DE\",\"eu\":true}]}")